/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadWarning } from './LeadWarning';
import {
    LeadWarningFromJSON,
    LeadWarningFromJSONTyped,
    LeadWarningToJSON,
    LeadWarningToJSONTyped,
} from './LeadWarning';
import type { ExternalEhrPatient } from './ExternalEhrPatient';
import {
    ExternalEhrPatientFromJSON,
    ExternalEhrPatientFromJSONTyped,
    ExternalEhrPatientToJSON,
    ExternalEhrPatientToJSONTyped,
} from './ExternalEhrPatient';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { PlaceholderField } from './PlaceholderField';
import {
    PlaceholderFieldFromJSON,
    PlaceholderFieldFromJSONTyped,
    PlaceholderFieldToJSON,
    PlaceholderFieldToJSONTyped,
} from './PlaceholderField';
import type { AiSuggestionSource } from './AiSuggestionSource';
import {
    AiSuggestionSourceFromJSON,
    AiSuggestionSourceFromJSONTyped,
    AiSuggestionSourceToJSON,
    AiSuggestionSourceToJSONTyped,
} from './AiSuggestionSource';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
    DocumentToJSONTyped,
} from './Document';
import type { AiAcceptOutcome } from './AiAcceptOutcome';
import {
    AiAcceptOutcomeFromJSON,
    AiAcceptOutcomeFromJSONTyped,
    AiAcceptOutcomeToJSON,
    AiAcceptOutcomeToJSONTyped,
} from './AiAcceptOutcome';
import type { LeadStatus } from './LeadStatus';
import {
    LeadStatusFromJSON,
    LeadStatusFromJSONTyped,
    LeadStatusToJSON,
    LeadStatusToJSONTyped,
} from './LeadStatus';
import type { ScreenerInsurance } from './ScreenerInsurance';
import {
    ScreenerInsuranceFromJSON,
    ScreenerInsuranceFromJSONTyped,
    ScreenerInsuranceToJSON,
    ScreenerInsuranceToJSONTyped,
} from './ScreenerInsurance';
import type { ScreenerSpecialCriteria } from './ScreenerSpecialCriteria';
import {
    ScreenerSpecialCriteriaFromJSON,
    ScreenerSpecialCriteriaFromJSONTyped,
    ScreenerSpecialCriteriaToJSON,
    ScreenerSpecialCriteriaToJSONTyped,
} from './ScreenerSpecialCriteria';
import type { LeadScreenerAdditionalDocumentsInner } from './LeadScreenerAdditionalDocumentsInner';
import {
    LeadScreenerAdditionalDocumentsInnerFromJSON,
    LeadScreenerAdditionalDocumentsInnerFromJSONTyped,
    LeadScreenerAdditionalDocumentsInnerToJSON,
    LeadScreenerAdditionalDocumentsInnerToJSONTyped,
} from './LeadScreenerAdditionalDocumentsInner';
import type { LeadScreenerLeadInfo } from './LeadScreenerLeadInfo';
import {
    LeadScreenerLeadInfoFromJSON,
    LeadScreenerLeadInfoFromJSONTyped,
    LeadScreenerLeadInfoToJSON,
    LeadScreenerLeadInfoToJSONTyped,
} from './LeadScreenerLeadInfo';
import type { TaskWorkflowProgress } from './TaskWorkflowProgress';
import {
    TaskWorkflowProgressFromJSON,
    TaskWorkflowProgressFromJSONTyped,
    TaskWorkflowProgressToJSON,
    TaskWorkflowProgressToJSONTyped,
} from './TaskWorkflowProgress';
import type { LeadScreenerLeadTagsInner } from './LeadScreenerLeadTagsInner';
import {
    LeadScreenerLeadTagsInnerFromJSON,
    LeadScreenerLeadTagsInnerFromJSONTyped,
    LeadScreenerLeadTagsInnerToJSON,
    LeadScreenerLeadTagsInnerToJSONTyped,
} from './LeadScreenerLeadTagsInner';
import type { LeadTimData } from './LeadTimData';
import {
    LeadTimDataFromJSON,
    LeadTimDataFromJSONTyped,
    LeadTimDataToJSON,
    LeadTimDataToJSONTyped,
} from './LeadTimData';
import type { SourceContact } from './SourceContact';
import {
    SourceContactFromJSON,
    SourceContactFromJSONTyped,
    SourceContactToJSON,
    SourceContactToJSONTyped,
} from './SourceContact';
import type { HomeHealthPractitionerAssignment } from './HomeHealthPractitionerAssignment';
import {
    HomeHealthPractitionerAssignmentFromJSON,
    HomeHealthPractitionerAssignmentFromJSONTyped,
    HomeHealthPractitionerAssignmentToJSON,
    HomeHealthPractitionerAssignmentToJSONTyped,
} from './HomeHealthPractitionerAssignment';
import type { LeadClaimedByFacility } from './LeadClaimedByFacility';
import {
    LeadClaimedByFacilityFromJSON,
    LeadClaimedByFacilityFromJSONTyped,
    LeadClaimedByFacilityToJSON,
    LeadClaimedByFacilityToJSONTyped,
} from './LeadClaimedByFacility';
import type { LeadWaitlist } from './LeadWaitlist';
import {
    LeadWaitlistFromJSON,
    LeadWaitlistFromJSONTyped,
    LeadWaitlistToJSON,
    LeadWaitlistToJSONTyped,
} from './LeadWaitlist';
import type { ScreenerDocumentError } from './ScreenerDocumentError';
import {
    ScreenerDocumentErrorFromJSON,
    ScreenerDocumentErrorFromJSONTyped,
    ScreenerDocumentErrorToJSON,
    ScreenerDocumentErrorToJSONTyped,
} from './ScreenerDocumentError';
import type { LeadAdmissionStatusInfo } from './LeadAdmissionStatusInfo';
import {
    LeadAdmissionStatusInfoFromJSON,
    LeadAdmissionStatusInfoFromJSONTyped,
    LeadAdmissionStatusInfoToJSON,
    LeadAdmissionStatusInfoToJSONTyped,
} from './LeadAdmissionStatusInfo';
import type { AnalysisResult } from './AnalysisResult';
import {
    AnalysisResultFromJSON,
    AnalysisResultFromJSONTyped,
    AnalysisResultToJSON,
    AnalysisResultToJSONTyped,
} from './AnalysisResult';
import type { LeadAssignmentSummary } from './LeadAssignmentSummary';
import {
    LeadAssignmentSummaryFromJSON,
    LeadAssignmentSummaryFromJSONTyped,
    LeadAssignmentSummaryToJSON,
    LeadAssignmentSummaryToJSONTyped,
} from './LeadAssignmentSummary';
import type { LeadSourceMergedInto } from './LeadSourceMergedInto';
import {
    LeadSourceMergedIntoFromJSON,
    LeadSourceMergedIntoFromJSONTyped,
    LeadSourceMergedIntoToJSON,
    LeadSourceMergedIntoToJSONTyped,
} from './LeadSourceMergedInto';
import type { LeadAdmissionFlagsInner } from './LeadAdmissionFlagsInner';
import {
    LeadAdmissionFlagsInnerFromJSON,
    LeadAdmissionFlagsInnerFromJSONTyped,
    LeadAdmissionFlagsInnerToJSON,
    LeadAdmissionFlagsInnerToJSONTyped,
} from './LeadAdmissionFlagsInner';
import type { AdmissionStatus } from './AdmissionStatus';
import {
    AdmissionStatusFromJSON,
    AdmissionStatusFromJSONTyped,
    AdmissionStatusToJSON,
    AdmissionStatusToJSONTyped,
} from './AdmissionStatus';
import type { EffectiveDecision } from './EffectiveDecision';
import {
    EffectiveDecisionFromJSON,
    EffectiveDecisionFromJSONTyped,
    EffectiveDecisionToJSON,
    EffectiveDecisionToJSONTyped,
} from './EffectiveDecision';
import type { Facility } from './Facility';
import {
    FacilityFromJSON,
    FacilityFromJSONTyped,
    FacilityToJSON,
    FacilityToJSONTyped,
} from './Facility';
import type { AdmissionStatusCode } from './AdmissionStatusCode';
import {
    AdmissionStatusCodeFromJSON,
    AdmissionStatusCodeFromJSONTyped,
    AdmissionStatusCodeToJSON,
    AdmissionStatusCodeToJSONTyped,
} from './AdmissionStatusCode';
import type { LeadCareAttributesInner } from './LeadCareAttributesInner';
import {
    LeadCareAttributesInnerFromJSON,
    LeadCareAttributesInnerFromJSONTyped,
    LeadCareAttributesInnerToJSON,
    LeadCareAttributesInnerToJSONTyped,
} from './LeadCareAttributesInner';

/**
 * 
 * @export
 * @interface Lead
 */
export interface Lead {
    /**
     * 
     */
    source_id: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    original_facility_id?: string | null;
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    lead_received_date: string;
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    source_name?: string;
    /**
     * 
     */
    source_merged_into?: LeadSourceMergedInto;
    /**
     * Whether this lead's source is soft-deleted, by merge or by plain deletion.
     */
    readonly source_deleted?: boolean;
    /**
     * Fields whose current values are placeholders and should be rendered as unconfirmed in the UI.
     */
    placeholder_fields?: Array<PlaceholderField>;
    /**
     * 
     */
    screener_suggestion?: LeadScreenerSuggestionEnum;
    /**
     * 
     */
    ai_suggestion?: LeadAiSuggestionEnum;
    /**
     * 
     */
    ai_suggestion_source?: AiSuggestionSource | null;
    /**
     * 
     */
    effective_decision?: EffectiveDecision;
    /**
     * 
     */
    status_id?: string;
    /**
     * 
     */
    failed_review_stage_status_id?: string | null;
    /**
     * 
     */
    bd_action_failed?: boolean | null;
    /**
     * 
     */
    status?: LeadStatus;
    /**
     * 
     */
    auto_accepted_by_ai?: boolean;
    /**
     * 
     */
    ai_accept_outcome?: AiAcceptOutcome | null;
    /**
     * 
     */
    documents?: Array<Document>;
    /**
     * 
     */
    analysis_results?: Array<AnalysisResult>;
    /**
     * 
     */
    report_s3_access_url?: string;
    /**
     * 
     */
    report_failure_reason?: LeadReportFailureReasonEnum;
    /**
     * 
     */
    special_criteria?: Array<ScreenerSpecialCriteria>;
    /**
     * 
     */
    pcc_pending_patient_id?: string;
    /**
     * 
     */
    external_ehr_patient_id?: string;
    /**
     * 
     */
    comments_summary?: string;
    /**
     * 
     */
    pcc_push_by_user?: User;
    /**
     * 
     */
    pcc_push_date?: string;
    /**
     * 
     */
    connector?: LeadConnectorEnum;
    /**
     * 
     */
    connector_no_sync?: boolean;
    /**
     * 
     */
    is_stub?: boolean;
    /**
     * 
     */
    connector_referral_id?: string;
    /**
     * 
     */
    connector_created_at?: string;
    /**
     * 
     */
    referral_deadline_at?: string | null;
    /**
     * 
     */
    gender?: string | null;
    /**
     * 
     */
    dob?: string | null;
    /**
     * 
     */
    medicaid_number?: string;
    /**
     * 
     */
    medicare_number?: string;
    /**
     * 
     */
    ssn?: string;
    /**
     * 
     */
    source_contact_id?: string | null;
    /**
     * 
     */
    source_discharge_date?: string | null;
    /**
     * 
     */
    original_move_in_date?: string;
    /**
     * 
     */
    source_contact?: SourceContact;
    /**
     * 
     */
    is_visual_references_ready?: boolean;
    /**
     * 
     */
    exclude_from_duplicate_check?: boolean;
    /**
     * 
     * @deprecated
     */
    claimed_by_facility?: LeadClaimedByFacility;
    /**
     * 
     */
    is_cancelled?: boolean;
    /**
     * 
     */
    duplicate_group_id?: string;
    /**
     * 
     */
    facility?: Facility;
    /**
     * 
     */
    created_at?: string;
    /**
     * 
     */
    is_large_document_ai_used?: boolean;
    /**
     * 
     */
    medications_extraction_complete?: boolean;
    /**
     * 
     */
    is_medication_analysis_completed?: boolean;
    /**
     * 
     */
    are_all_documents_analyzed?: boolean;
    /**
     * 
     */
    has_insufficient_document_context?: boolean;
    /**
     * 
     */
    s_offender_records_stored?: boolean;
    /**
     * 
     */
    s_offender_check_failed?: boolean;
    /**
     * 
     */
    medicare_estimates_status?: LeadMedicareEstimatesStatusEnum;
    /**
     * 
     */
    medicare_estimates_visual_refs_ready?: boolean;
    /**
     * 
     */
    source_comments?: string | null;
    /**
     * 
     */
    source_comments_received_at?: string;
    /**
     * 
     */
    declined_reason?: string;
    /**
     * 
     */
    request_info_reason?: string;
    /**
     * 
     */
    internal_response_reason?: string;
    /**
     * 
     */
    external_response_reason?: string;
    /**
     * 
     */
    external_ehr_patient?: ExternalEhrPatient;
    /**
     * Legacy display name. Use `admission_status_code`.
     * @deprecated
     */
    admission_status?: AdmissionStatus;
    /**
     * 
     */
    admission_status_code?: AdmissionStatusCode;
    /**
     * 
     */
    admission_status_info?: LeadAdmissionStatusInfo;
    /**
     * 
     */
    previous_admission_status_info?: LeadAdmissionStatusInfo;
    /**
     * 
     */
    insurances?: Array<ScreenerInsurance>;
    /**
     * 
     */
    screener_lead_info?: LeadScreenerLeadInfo;
    /**
     * 
     */
    screener_lead_tags?: Array<LeadScreenerLeadTagsInner>;
    /**
     * 
     */
    care_attributes?: Array<LeadCareAttributesInner>;
    /**
     * 
     */
    tim_data?: LeadTimData;
    /**
     * 
     */
    has_no_epic_ehr_access?: boolean;
    /**
     * 
     */
    has_start_review_hang?: boolean;
    /**
     * 
     */
    admission_flags?: Array<LeadAdmissionFlagsInner>;
    /**
     * 
     */
    waitlist?: LeadWaitlist;
    /**
     * 
     */
    document_errors?: Array<ScreenerDocumentError>;
    /**
     * 
     */
    has_new_hospital_messages?: boolean;
    /**
     * 
     */
    task_workflow_progress?: TaskWorkflowProgress;
    /**
     * 
     */
    screener_additional_documents?: Array<LeadScreenerAdditionalDocumentsInner>;
    /**
     * 
     */
    has_previous_stay_in_facility?: boolean;
    /**
     * 
     */
    readmit_from_hospital?: boolean;
    /**
     * 
     */
    prev_stay_set_by_user?: User;
    /**
     * 
     */
    lead_warnings?: Array<LeadWarning>;
    /**
     * Active Owner and Source Liaison assignments on this referral. IDs only — render via the top-level users sidecar on the response.
     */
    assignments?: Array<LeadAssignmentSummary>;
    /**
     * Current clinical practitioner assignments for a home-health lead.
     */
    readonly home_health_practitioner_assignments?: Array<HomeHealthPractitionerAssignment>;
}


/**
 * @export
 */
export const LeadScreenerSuggestionEnum = {
    Accept: 'Accept',
    Reject: 'Reject',
    Maybe: 'Maybe',
    Pending: 'Pending',
    Cancelled: 'Cancelled',
    NA: 'N/A',
} as const;
export type LeadScreenerSuggestionEnum = typeof LeadScreenerSuggestionEnum[keyof typeof LeadScreenerSuggestionEnum];

/**
 * @export
 */
export const LeadAiSuggestionEnum = {
    Accept: 'Accept',
    Reject: 'Reject',
    Maybe: 'Maybe',
    Pending: 'Pending',
    Cancelled: 'Cancelled',
    NA: 'N/A',
} as const;
export type LeadAiSuggestionEnum = typeof LeadAiSuggestionEnum[keyof typeof LeadAiSuggestionEnum];

/**
 * @export
 */
export const LeadReportFailureReasonEnum = {
    ReportTooShort: 'report_too_short',
} as const;
export type LeadReportFailureReasonEnum = typeof LeadReportFailureReasonEnum[keyof typeof LeadReportFailureReasonEnum];

/**
 * @export
 */
export const LeadConnectorEnum = {
    Aida: 'Aida',
    Aidin: 'Aidin',
    Ensocare: 'Ensocare',
    EnsocareVa: 'Ensocare VA',
    EpicCareLink: 'EpicCare Link',
    EpicCareLinkAlbanyMed: 'EpicCare Link Albany Med',
    EpicCareLinkAllinaHealth: 'EpicCare Link Allina Health',
    EpicCareLinkAsante: 'EpicCare Link Asante',
    EpicCareLinkAscension: 'EpicCare Link Ascension',
    EpicCareLinkAscensionWi: 'EpicCare Link Ascension WI',
    EpicCareLinkAspirusHealth: 'EpicCare Link Aspirus Health',
    EpicCareLinkAtriumHealth: 'EpicCare Link Atrium Health',
    EpicCareLinkBaptistHealth: 'EpicCare Link Baptist Health',
    EpicCareLinkBaptistOneCare: 'EpicCare Link Baptist One Care',
    EpicCareLinkBenefisHealthSystem: 'EpicCare Link Benefis Health System',
    EpicCareLinkBaylorScottWhiteHealth: 'EpicCare Link Baylor Scott & White Health',
    EpicCareLinkBonSecoursMercyHealth: 'EpicCare Link Bon Secours Mercy Health',
    EpicCareLinkBostonMedicalCenter: 'EpicCare Link Boston Medical Center',
    EpicCareLinkBronsonHealthcare: 'EpicCare Link Bronson Healthcare',
    EpicCareLinkBryanHealth: 'EpicCare Link Bryan Health',
    EpicCareLinkBsaHospital: 'EpicCare Link BSA Hospital',
    EpicCareLinkCapeCodHealthcare: 'EpicCare Link Cape Cod Healthcare',
    EpicCareLinkCaroMont: 'EpicCare Link CaroMont',
    EpicCareLinkCarolinaEast: 'EpicCare Link Carolina East',
    EpicCareLinkErlanger: 'EpicCare Link Erlanger',
    EpicCareLinkCentraCare: 'EpicCare Link CentraCare',
    EpicCareLinkChristusHealth: 'EpicCare Link CHRISTUS Health',
    EpicCareLinkConeHealth: 'EpicCare Link Cone Health',
    EpicCareLinkCovenantHealthCare: 'EpicCare Link Covenant HealthCare',
    EpicCareLinkDeaconess: 'EpicCare Link Deaconess',
    EpicCareLinkDenverHealth: 'EpicCare Link Denver Health',
    EpicCareLinkDukeHealth: 'EpicCare Link Duke Health',
    EpicCareLinkEcuHealth: 'EpicCare Link ECU Health',
    EpicCareLinkElCaminoHealth: 'EpicCare Link El Camino Health',
    EpicCareLinkEnloeHealth: 'EpicCare Link Enloe Health',
    EpicCareLinkFirstHealth: 'EpicCare Link FirstHealth',
    EpicCareLinkFmolhsCareConnect: 'EpicCare Link FMOLHS CareConnect',
    EpicCareLinkSelectMedical: 'EpicCare Link Select Medical',
    EpicCareLinkParkview: 'EpicCare Link Parkview',
    EpicCareLinkGenesisHealthcareSystem: 'EpicCare Link Genesis Healthcare System',
    EpicCareLinkGuthrie: 'EpicCare Link Guthrie',
    EpicCareLinkHartfordHealthCare: 'EpicCare Link Hartford HealthCare',
    EpicCareLinkHackensackMeridianHealth: 'EpicCare Link Hackensack Meridian Health',
    EpicCareLinkHealthPartners: 'EpicCare Link HealthPartners',
    EpicCareLinkHealtheConnection: 'EpicCare Link HealtheConnection',
    EpicCareLinkHennepinCountyMedicalCenter: 'EpicCare Link Hennepin County Medical Center',
    EpicCareLinkHillcrestHealthCareSystem: 'EpicCare Link Hillcrest HealthCare System',
    EpicCareLinkHospitalSistersHealthSystem: 'EpicCare Link Hospital Sisters Health System',
    EpicCareLinkHurleyMedicalCenter: 'EpicCare Link Hurley Medical Center',
    EpicCareLinkIowaHealthCare: 'EpicCare Link Iowa Health Care',
    EpicCareLinkIntegrisHealth: 'EpicCare Link Integris Health',
    EpicCareLinkJupiterMedicalCenter: 'EpicCare Link Jupiter Medical Center',
    EpicCareLinkKaiserPermanente: 'EpicCare Link Kaiser Permanente',
    EpicCareLinkKingsDaughtersHealthSystem: 'EpicCare Link King\'s Daughters Health System',
    EpicCareLinkLegacyHealthyPlanet: 'EpicCare Link Legacy Healthy Planet',
    EpicCareLinkMHealthFairview: 'EpicCare Link M Health Fairview',
    EpicCareLinkMainLineHealth: 'EpicCare Link Main Line Health',
    EpicCareLinkMayoClinic: 'EpicCare Link Mayo Clinic',
    EpicCareLinkMercy: 'EpicCare Link Mercy',
    EpicCareLinkMethodistHospitals: 'EpicCare Link Methodist Hospitals',
    EpicCareLinkMethodistHealthSystem: 'EpicCare Link Methodist Health System',
    EpicCareLinkMiddlesexHealth: 'EpicCare Link Middlesex Health',
    EpicCareLinkMyMichiganHealth: 'EpicCare Link MyMichigan Health',
    EpicCareLinkNch: 'EpicCare Link NCH',
    EpicCareLinkNortonHealthcare: 'EpicCare Link Norton Healthcare',
    EpicCareLinkNorthMemorialHealth: 'EpicCare Link North Memorial Health',
    EpicCareLinkOchsnerHealthNetwork: 'EpicCare Link Ochsner Health Network',
    EpicCareLinkOhioHealth: 'EpicCare Link OhioHealth',
    EpicCareLinkOklahomaHeartHospital: 'EpicCare Link Oklahoma Heart Hospital',
    EpicCareLinkOsfHealthCare: 'EpicCare Link OSF HealthCare',
    EpicCareLinkOwensboroHealth: 'EpicCare Link Owensboro Health',
    EpicCareLinkPennMedicine: 'EpicCare Link Penn Medicine',
    EpicCareLinkPiedmont: 'EpicCare Link Piedmont',
    EpicCareLinkProvidence: 'EpicCare Link Providence',
    EpicCareLinkProvidenceWashington: 'EpicCare Link Providence Washington',
    EpicCareLinkSaintFrancis: 'EpicCare Link Saint Francis',
    EpicCareLinkSalemHealth: 'EpicCare Link Salem Health',
    EpicCareLinkShannonHealth: 'EpicCare Link Shannon Health',
    EpicCareLinkStElizabethHealthcare: 'EpicCare Link St. Elizabeth Healthcare',
    EpicCareLinkStormontVailHealth: 'EpicCare Link Stormont Vail Health',
    EpicCareLinkSsmHealth: 'EpicCare Link SSM Health',
    EpicCareLinkTexasHealth: 'EpicCare Link Texas Health',
    EpicCareLinkTheQueensHealthSystem: 'EpicCare Link The Queen\'s Health System',
    EpicCareLinkThedaCare: 'EpicCare Link ThedaCare',
    EpicCareLinkTriHealth: 'EpicCare Link TriHealth',
    EpicCareLinkTrinityHealth: 'EpicCare Link Trinity Health',
    EpicCareLinkUcHealth: 'EpicCare Link UCHealth',
    EpicCareLinkUncHealth: 'EpicCare Link UNC Health',
    EpicCareLinkUConnHealth: 'EpicCare Link UConn Health',
    EpicCareLinkUnityPointHealth: 'EpicCare Link UnityPoint Health',
    EpicCareLinkUniversityOfCincinnati: 'EpicCare Link University of Cincinnati',
    EpicCareLinkUniversityOfKansas: 'EpicCare Link University of Kansas',
    EpicCareLinkUniversityOfKansasStFrancis: 'EpicCare Link University of Kansas St Francis',
    EpicCareLinkUniversityOfMarylandMedicalSystem: 'EpicCare Link University of Maryland Medical System',
    EpicCareLinkUniversityOfMississippiMedicalCenter: 'EpicCare Link University of Mississippi Medical Center',
    EpicCareLinkUniversityOfRochesterMedicine: 'EpicCare Link University of Rochester Medicine',
    EpicCareLinkUniversityHealth: 'EpicCare Link University Health',
    EpicCareLinkUniversityOfUtah: 'EpicCare Link University of Utah',
    EpicCareLinkUpmcPinnacle: 'EpicCare Link UPMC Pinnacle',
    EpicCareLinkSouthShoreHealth: 'EpicCare Link South Shore Health',
    EpicCareLinkSouthcoast: 'EpicCare Link Southcoast',
    EpicCareLinkStLukes: 'EpicCare Link St. Luke\'s',
    EpicCareLinkPremierHealth: 'EpicCare Link Premier Health',
    EpicCareLinkUtHealthEastTexas: 'EpicCare Link UT Health East Texas',
    EpicCareLinkUtSouthwesternMedicalCenter: 'EpicCare Link UT Southwestern Medical Center',
    EpicCareLinkVitruvianHealth: 'EpicCare Link Vitruvian Health',
    EpicCareLinkWellstar: 'EpicCare Link Wellstar',
    EpicCareLinkKetteringHealth: 'EpicCare Link Kettering Health',
    EpicCareLinkOlmstedMedicalCenter: 'EpicCare Link Olmsted Medical Center',
    EpicCareLinkFranciscanHealth: 'EpicCare Link Franciscan Health',
    EpicCareLinkMohawkValleyHealthSystem: 'EpicCare Link Mohawk Valley Health System',
    EpicCareLinkGeisinger: 'EpicCare Link Geisinger',
    EpicCareLinkJpsHealthNetwork: 'EpicCare Link JPS Health Network',
    EpicCareLinkPortneuf: 'EpicCare Link Portneuf',
    EpicCareLinkCheyenneRegionalMedicalCenter: 'EpicCare Link Cheyenne Regional Medical Center',
    EpicCareLinkUniversityMedicalCenter: 'EpicCare Link University Medical Center',
    EpicCareLinkCapeFearValley: 'EpicCare Link Cape Fear Valley',
    EpicCareLinkLexingtonMedicalCenter: 'EpicCare Link Lexington Medical Center',
    EpicCareLinkMedicalUniversityOfSouthCarolina: 'EpicCare Link Medical University of South Carolina',
    EpicCareLinkEssentiaHealth: 'EpicCare Link Essentia Health',
    EpicCareLinkUwHealth: 'EpicCare Link UW Health',
    EpicCareLinkNorthMississippiHealthServices: 'EpicCare Link North Mississippi Health Services',
    EpicCareLinkOregonHealthScienceUniversity: 'EpicCare Link Oregon Health & Science University',
    EpicCareLinkLcmcHealth: 'EpicCare Link LCMC Health',
    EpicCareLinkRwjBarnabas: 'EpicCare Link RWJ Barnabas',
    EpicCareLinkLovelaceHealthSystem: 'EpicCare Link Lovelace Health System',
    EpicCareLinkRochesterRegionalHealth: 'EpicCare Link Rochester Regional Health',
    EpicCareLinkAtlanticHealth: 'EpicCare Link Atlantic Health',
    EpicCareLinkBalladHealth: 'EpicCare Link Ballad Health',
    EpicCareLinkGreatRiver: 'EpicCare Link Great River',
    EpicCareLinkMountainsideMedicalCenter: 'EpicCare Link Mountainside Medical Center',
    EpicCareLinkUkHealthCare: 'EpicCare Link UK HealthCare',
    EpicCareLinkCghMedicalCenter: 'EpicCare Link CGH Medical Center',
    EpicCareLinkMosaicLifeCare: 'EpicCare Link Mosaic Life Care',
    EpicCareLinkGundersenHealth: 'EpicCare Link Gundersen Health',
    EpicCareLinkCoxHealth: 'EpicCare Link CoxHealth',
    EpicCareLinkSingingRiver: 'EpicCare Link Singing River',
    EpicCareLinkLickingMemorialHealth: 'EpicCare Link Licking Memorial Health',
    EpicCareLinkWakeMed: 'EpicCare Link WakeMed',
    EpicCareLinkAdventist: 'EpicCare Link Adventist',
    EpicCareLinkEvergreenHealth: 'EpicCare Link Evergreen Health',
    EpicCrnVendorServicesSandbox: 'Epic CRN Vendor Services Sandbox',
    EpicCrnUmms: 'Epic CRN UMMS',
    Fax: 'Fax',
    ManualUpload: 'Manual Upload',
    ManualCopy: 'Manual Copy',
    Repisodic: 'Repisodic',
    WellSkyIntake: 'WellSky Intake',
    WellSkyIntakeCarePortQuickCase: 'WellSky Intake CarePort QuickCase',
    WellSkyCarePortReferralIntake: 'WellSky CarePort Referral Intake',
    WellSkyReferralManagement: 'WellSky Referral Management',
    WellSkyReferralManagementWebReferral: 'WellSky Referral Management Web Referral',
    FourNext: 'Four Next',
    Roc: 'Roc',
} as const;
export type LeadConnectorEnum = typeof LeadConnectorEnum[keyof typeof LeadConnectorEnum];

/**
 * @export
 */
export const LeadMedicareEstimatesStatusEnum = {
    NotActive: 'not_active',
    NotEnoughData: 'not_enough_data',
    InProgress: 'in_progress',
    Completed: 'completed',
    Error: 'error',
    Disabled: 'disabled',
    Scheduled: 'scheduled',
} as const;
export type LeadMedicareEstimatesStatusEnum = typeof LeadMedicareEstimatesStatusEnum[keyof typeof LeadMedicareEstimatesStatusEnum];


/**
 * Check if a given object implements the Lead interface.
 */
export function instanceOfLead(value: object): value is Lead {
    if (!('source_id' in value) || value['source_id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('lead_received_date' in value) || value['lead_received_date'] === undefined) return false;
    return true;
}

export function LeadFromJSON(json: any): Lead {
    return LeadFromJSONTyped(json, false);
}

export function LeadFromJSONTyped(json: any, ignoreDiscriminator: boolean): Lead {
    if (json == null) {
        return json;
    }
    return {
        
        'source_id': json['source_id'],
        'facility_id': json['facility_id'],
        'original_facility_id': json['original_facility_id'] === undefined ? undefined : json['original_facility_id'] === null ? null : json['original_facility_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'lead_received_date': json['lead_received_date'],
        'id': json['id'] == null ? undefined : json['id'],
        'source_name': json['source_name'] == null ? undefined : json['source_name'],
        'source_merged_into': json['source_merged_into'] == null ? undefined : LeadSourceMergedIntoFromJSON(json['source_merged_into']),
        'source_deleted': json['source_deleted'] == null ? undefined : json['source_deleted'],
        'placeholder_fields': json['placeholder_fields'] == null ? undefined : ((json['placeholder_fields'] as Array<any>).map(PlaceholderFieldFromJSON)),
        'screener_suggestion': json['screener_suggestion'] == null ? undefined : json['screener_suggestion'],
        'ai_suggestion': json['ai_suggestion'] == null ? undefined : json['ai_suggestion'],
        'ai_suggestion_source': json['ai_suggestion_source'] === undefined ? undefined : json['ai_suggestion_source'] === null ? null : AiSuggestionSourceFromJSON(json['ai_suggestion_source']),
        'effective_decision': json['effective_decision'] == null ? undefined : EffectiveDecisionFromJSON(json['effective_decision']),
        'status_id': json['status_id'] == null ? undefined : json['status_id'],
        'failed_review_stage_status_id': json['failed_review_stage_status_id'] === undefined ? undefined : json['failed_review_stage_status_id'] === null ? null : json['failed_review_stage_status_id'],
        'bd_action_failed': json['bd_action_failed'] === undefined ? undefined : json['bd_action_failed'] === null ? null : json['bd_action_failed'],
        'status': json['status'] == null ? undefined : LeadStatusFromJSON(json['status']),
        'auto_accepted_by_ai': json['auto_accepted_by_ai'] == null ? undefined : json['auto_accepted_by_ai'],
        'ai_accept_outcome': json['ai_accept_outcome'] === undefined ? undefined : json['ai_accept_outcome'] === null ? null : AiAcceptOutcomeFromJSON(json['ai_accept_outcome']),
        'documents': json['documents'] == null ? undefined : ((json['documents'] as Array<any>).map(DocumentFromJSON)),
        'analysis_results': json['analysis_results'] == null ? undefined : ((json['analysis_results'] as Array<any>).map(AnalysisResultFromJSON)),
        'report_s3_access_url': json['report_s3_access_url'] == null ? undefined : json['report_s3_access_url'],
        'report_failure_reason': json['report_failure_reason'] == null ? undefined : json['report_failure_reason'],
        'special_criteria': json['special_criteria'] == null ? undefined : ((json['special_criteria'] as Array<any>).map(ScreenerSpecialCriteriaFromJSON)),
        'pcc_pending_patient_id': json['pcc_pending_patient_id'] == null ? undefined : json['pcc_pending_patient_id'],
        'external_ehr_patient_id': json['external_ehr_patient_id'] == null ? undefined : json['external_ehr_patient_id'],
        'comments_summary': json['comments_summary'] == null ? undefined : json['comments_summary'],
        'pcc_push_by_user': json['pcc_push_by_user'] == null ? undefined : UserFromJSON(json['pcc_push_by_user']),
        'pcc_push_date': json['pcc_push_date'] == null ? undefined : json['pcc_push_date'],
        'connector': json['connector'] == null ? undefined : json['connector'],
        'connector_no_sync': json['connector_no_sync'] == null ? undefined : json['connector_no_sync'],
        'is_stub': json['is_stub'] == null ? undefined : json['is_stub'],
        'connector_referral_id': json['connector_referral_id'] == null ? undefined : json['connector_referral_id'],
        'connector_created_at': json['connector_created_at'] == null ? undefined : json['connector_created_at'],
        'referral_deadline_at': json['referral_deadline_at'] === undefined ? undefined : json['referral_deadline_at'] === null ? null : json['referral_deadline_at'],
        'gender': json['gender'] === undefined ? undefined : json['gender'] === null ? null : json['gender'],
        'dob': json['dob'] === undefined ? undefined : json['dob'] === null ? null : json['dob'],
        'medicaid_number': json['medicaid_number'] == null ? undefined : json['medicaid_number'],
        'medicare_number': json['medicare_number'] == null ? undefined : json['medicare_number'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'source_contact_id': json['source_contact_id'] === undefined ? undefined : json['source_contact_id'] === null ? null : json['source_contact_id'],
        'source_discharge_date': json['source_discharge_date'] === undefined ? undefined : json['source_discharge_date'] === null ? null : json['source_discharge_date'],
        'original_move_in_date': json['original_move_in_date'] == null ? undefined : json['original_move_in_date'],
        'source_contact': json['source_contact'] == null ? undefined : SourceContactFromJSON(json['source_contact']),
        'is_visual_references_ready': json['is_visual_references_ready'] == null ? undefined : json['is_visual_references_ready'],
        'exclude_from_duplicate_check': json['exclude_from_duplicate_check'] == null ? undefined : json['exclude_from_duplicate_check'],
        'claimed_by_facility': json['claimed_by_facility'] == null ? undefined : LeadClaimedByFacilityFromJSON(json['claimed_by_facility']),
        'is_cancelled': json['is_cancelled'] == null ? undefined : json['is_cancelled'],
        'duplicate_group_id': json['duplicate_group_id'] == null ? undefined : json['duplicate_group_id'],
        'facility': json['facility'] == null ? undefined : FacilityFromJSON(json['facility']),
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
        'is_large_document_ai_used': json['is_large_document_ai_used'] == null ? undefined : json['is_large_document_ai_used'],
        'medications_extraction_complete': json['medications_extraction_complete'] == null ? undefined : json['medications_extraction_complete'],
        'is_medication_analysis_completed': json['is_medication_analysis_completed'] == null ? undefined : json['is_medication_analysis_completed'],
        'are_all_documents_analyzed': json['are_all_documents_analyzed'] == null ? undefined : json['are_all_documents_analyzed'],
        'has_insufficient_document_context': json['has_insufficient_document_context'] == null ? undefined : json['has_insufficient_document_context'],
        's_offender_records_stored': json['s_offender_records_stored'] == null ? undefined : json['s_offender_records_stored'],
        's_offender_check_failed': json['s_offender_check_failed'] == null ? undefined : json['s_offender_check_failed'],
        'medicare_estimates_status': json['medicare_estimates_status'] == null ? undefined : json['medicare_estimates_status'],
        'medicare_estimates_visual_refs_ready': json['medicare_estimates_visual_refs_ready'] == null ? undefined : json['medicare_estimates_visual_refs_ready'],
        'source_comments': json['source_comments'] === undefined ? undefined : json['source_comments'] === null ? null : json['source_comments'],
        'source_comments_received_at': json['source_comments_received_at'] == null ? undefined : json['source_comments_received_at'],
        'declined_reason': json['declined_reason'] == null ? undefined : json['declined_reason'],
        'request_info_reason': json['request_info_reason'] == null ? undefined : json['request_info_reason'],
        'internal_response_reason': json['internal_response_reason'] == null ? undefined : json['internal_response_reason'],
        'external_response_reason': json['external_response_reason'] == null ? undefined : json['external_response_reason'],
        'external_ehr_patient': json['external_ehr_patient'] == null ? undefined : ExternalEhrPatientFromJSON(json['external_ehr_patient']),
        'admission_status': json['admission_status'] == null ? undefined : AdmissionStatusFromJSON(json['admission_status']),
        'admission_status_code': json['admission_status_code'] == null ? undefined : AdmissionStatusCodeFromJSON(json['admission_status_code']),
        'admission_status_info': json['admission_status_info'] == null ? undefined : LeadAdmissionStatusInfoFromJSON(json['admission_status_info']),
        'previous_admission_status_info': json['previous_admission_status_info'] == null ? undefined : LeadAdmissionStatusInfoFromJSON(json['previous_admission_status_info']),
        'insurances': json['insurances'] == null ? undefined : ((json['insurances'] as Array<any>).map(ScreenerInsuranceFromJSON)),
        'screener_lead_info': json['screener_lead_info'] == null ? undefined : LeadScreenerLeadInfoFromJSON(json['screener_lead_info']),
        'screener_lead_tags': json['screener_lead_tags'] == null ? undefined : ((json['screener_lead_tags'] as Array<any>).map(LeadScreenerLeadTagsInnerFromJSON)),
        'care_attributes': json['care_attributes'] == null ? undefined : ((json['care_attributes'] as Array<any>).map(LeadCareAttributesInnerFromJSON)),
        'tim_data': json['tim_data'] == null ? undefined : LeadTimDataFromJSON(json['tim_data']),
        'has_no_epic_ehr_access': json['has_no_epic_ehr_access'] == null ? undefined : json['has_no_epic_ehr_access'],
        'has_start_review_hang': json['has_start_review_hang'] == null ? undefined : json['has_start_review_hang'],
        'admission_flags': json['admission_flags'] == null ? undefined : ((json['admission_flags'] as Array<any>).map(LeadAdmissionFlagsInnerFromJSON)),
        'waitlist': json['waitlist'] == null ? undefined : LeadWaitlistFromJSON(json['waitlist']),
        'document_errors': json['document_errors'] == null ? undefined : ((json['document_errors'] as Array<any>).map(ScreenerDocumentErrorFromJSON)),
        'has_new_hospital_messages': json['has_new_hospital_messages'] == null ? undefined : json['has_new_hospital_messages'],
        'task_workflow_progress': json['task_workflow_progress'] == null ? undefined : TaskWorkflowProgressFromJSON(json['task_workflow_progress']),
        'screener_additional_documents': json['screener_additional_documents'] == null ? undefined : ((json['screener_additional_documents'] as Array<any>).map(LeadScreenerAdditionalDocumentsInnerFromJSON)),
        'has_previous_stay_in_facility': json['has_previous_stay_in_facility'] == null ? undefined : json['has_previous_stay_in_facility'],
        'readmit_from_hospital': json['readmit_from_hospital'] == null ? undefined : json['readmit_from_hospital'],
        'prev_stay_set_by_user': json['prev_stay_set_by_user'] == null ? undefined : UserFromJSON(json['prev_stay_set_by_user']),
        'lead_warnings': json['lead_warnings'] == null ? undefined : ((json['lead_warnings'] as Array<any>).map(LeadWarningFromJSON)),
        'assignments': json['assignments'] == null ? undefined : ((json['assignments'] as Array<any>).map(LeadAssignmentSummaryFromJSON)),
        'home_health_practitioner_assignments': json['home_health_practitioner_assignments'] == null ? undefined : ((json['home_health_practitioner_assignments'] as Array<any>).map(HomeHealthPractitionerAssignmentFromJSON)),
    };
}

export function LeadToJSON(json: any): Lead {
    return LeadToJSONTyped(json, false);
}

export function LeadToJSONTyped(value?: Omit<Lead, 'source_deleted'|'home_health_practitioner_assignments'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source_id': value['source_id'],
        'facility_id': value['facility_id'],
        'original_facility_id': value['original_facility_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'lead_received_date': value['lead_received_date'],
        'id': value['id'],
        'source_name': value['source_name'],
        'source_merged_into': LeadSourceMergedIntoToJSON(value['source_merged_into']),
        'placeholder_fields': value['placeholder_fields'] == null ? undefined : ((value['placeholder_fields'] as Array<any>).map(PlaceholderFieldToJSON)),
        'screener_suggestion': value['screener_suggestion'],
        'ai_suggestion': value['ai_suggestion'],
        'ai_suggestion_source': AiSuggestionSourceToJSON(value['ai_suggestion_source']),
        'effective_decision': EffectiveDecisionToJSON(value['effective_decision']),
        'status_id': value['status_id'],
        'failed_review_stage_status_id': value['failed_review_stage_status_id'],
        'bd_action_failed': value['bd_action_failed'],
        'status': LeadStatusToJSON(value['status']),
        'auto_accepted_by_ai': value['auto_accepted_by_ai'],
        'ai_accept_outcome': AiAcceptOutcomeToJSON(value['ai_accept_outcome']),
        'documents': value['documents'] == null ? undefined : ((value['documents'] as Array<any>).map(DocumentToJSON)),
        'analysis_results': value['analysis_results'] == null ? undefined : ((value['analysis_results'] as Array<any>).map(AnalysisResultToJSON)),
        'report_s3_access_url': value['report_s3_access_url'],
        'report_failure_reason': value['report_failure_reason'],
        'special_criteria': value['special_criteria'] == null ? undefined : ((value['special_criteria'] as Array<any>).map(ScreenerSpecialCriteriaToJSON)),
        'pcc_pending_patient_id': value['pcc_pending_patient_id'],
        'external_ehr_patient_id': value['external_ehr_patient_id'],
        'comments_summary': value['comments_summary'],
        'pcc_push_by_user': UserToJSON(value['pcc_push_by_user']),
        'pcc_push_date': value['pcc_push_date'],
        'connector': value['connector'],
        'connector_no_sync': value['connector_no_sync'],
        'is_stub': value['is_stub'],
        'connector_referral_id': value['connector_referral_id'],
        'connector_created_at': value['connector_created_at'],
        'referral_deadline_at': value['referral_deadline_at'],
        'gender': value['gender'],
        'dob': value['dob'],
        'medicaid_number': value['medicaid_number'],
        'medicare_number': value['medicare_number'],
        'ssn': value['ssn'],
        'source_contact_id': value['source_contact_id'],
        'source_discharge_date': value['source_discharge_date'],
        'original_move_in_date': value['original_move_in_date'],
        'source_contact': SourceContactToJSON(value['source_contact']),
        'is_visual_references_ready': value['is_visual_references_ready'],
        'exclude_from_duplicate_check': value['exclude_from_duplicate_check'],
        'claimed_by_facility': LeadClaimedByFacilityToJSON(value['claimed_by_facility']),
        'is_cancelled': value['is_cancelled'],
        'duplicate_group_id': value['duplicate_group_id'],
        'facility': FacilityToJSON(value['facility']),
        'created_at': value['created_at'],
        'is_large_document_ai_used': value['is_large_document_ai_used'],
        'medications_extraction_complete': value['medications_extraction_complete'],
        'is_medication_analysis_completed': value['is_medication_analysis_completed'],
        'are_all_documents_analyzed': value['are_all_documents_analyzed'],
        'has_insufficient_document_context': value['has_insufficient_document_context'],
        's_offender_records_stored': value['s_offender_records_stored'],
        's_offender_check_failed': value['s_offender_check_failed'],
        'medicare_estimates_status': value['medicare_estimates_status'],
        'medicare_estimates_visual_refs_ready': value['medicare_estimates_visual_refs_ready'],
        'source_comments': value['source_comments'],
        'source_comments_received_at': value['source_comments_received_at'],
        'declined_reason': value['declined_reason'],
        'request_info_reason': value['request_info_reason'],
        'internal_response_reason': value['internal_response_reason'],
        'external_response_reason': value['external_response_reason'],
        'external_ehr_patient': ExternalEhrPatientToJSON(value['external_ehr_patient']),
        'admission_status': AdmissionStatusToJSON(value['admission_status']),
        'admission_status_code': AdmissionStatusCodeToJSON(value['admission_status_code']),
        'admission_status_info': LeadAdmissionStatusInfoToJSON(value['admission_status_info']),
        'previous_admission_status_info': LeadAdmissionStatusInfoToJSON(value['previous_admission_status_info']),
        'insurances': value['insurances'] == null ? undefined : ((value['insurances'] as Array<any>).map(ScreenerInsuranceToJSON)),
        'screener_lead_info': LeadScreenerLeadInfoToJSON(value['screener_lead_info']),
        'screener_lead_tags': value['screener_lead_tags'] == null ? undefined : ((value['screener_lead_tags'] as Array<any>).map(LeadScreenerLeadTagsInnerToJSON)),
        'care_attributes': value['care_attributes'] == null ? undefined : ((value['care_attributes'] as Array<any>).map(LeadCareAttributesInnerToJSON)),
        'tim_data': LeadTimDataToJSON(value['tim_data']),
        'has_no_epic_ehr_access': value['has_no_epic_ehr_access'],
        'has_start_review_hang': value['has_start_review_hang'],
        'admission_flags': value['admission_flags'] == null ? undefined : ((value['admission_flags'] as Array<any>).map(LeadAdmissionFlagsInnerToJSON)),
        'waitlist': LeadWaitlistToJSON(value['waitlist']),
        'document_errors': value['document_errors'] == null ? undefined : ((value['document_errors'] as Array<any>).map(ScreenerDocumentErrorToJSON)),
        'has_new_hospital_messages': value['has_new_hospital_messages'],
        'task_workflow_progress': TaskWorkflowProgressToJSON(value['task_workflow_progress']),
        'screener_additional_documents': value['screener_additional_documents'] == null ? undefined : ((value['screener_additional_documents'] as Array<any>).map(LeadScreenerAdditionalDocumentsInnerToJSON)),
        'has_previous_stay_in_facility': value['has_previous_stay_in_facility'],
        'readmit_from_hospital': value['readmit_from_hospital'],
        'prev_stay_set_by_user': UserToJSON(value['prev_stay_set_by_user']),
        'lead_warnings': value['lead_warnings'] == null ? undefined : ((value['lead_warnings'] as Array<any>).map(LeadWarningToJSON)),
        'assignments': value['assignments'] == null ? undefined : ((value['assignments'] as Array<any>).map(LeadAssignmentSummaryToJSON)),
    };
}

